var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),(!_vm.validando)?_c('b-button',{attrs:{"variant":_vm.data.item.estatusReplicaCdx == 'Sin réplica' 
        ? 'outline-warning'
        : 'outline-success',"disabled":_vm.data.item.estatusReplicaCdx !== 'Sin réplica'
  && _vm.data.item.estatusReplicaCdx === 'Proceso'},on:{"click":function($event){return _vm.deleteFinalizarSolicitud(
        _vm.data.item.idSolicitudBandejaEspecialista,
        _vm.data.item.replica,
         _vm.data.item.estatusReplicaCdx,
         _vm.data.item.idSolicitudEtapa
      )}}},[_vm._v("Validar")]):_c('b-button',{attrs:{"disabled":"","variant":"success"}},[_c('b-spinner',{attrs:{"small":""}}),_vm._v(" Validando... ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }